/**
 * @file ChartWindowNav.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-07-21
 * @modified 2026-07-21
 * @description Chevron overlay for paging a history chart back / forward in time,
 *              plus a centred label of the period on screen. Rendered inside a
 *              position:relative chart container (see .chart-window-nav in
 *              ChartWindowNav.css). Buttons disable at the ends of the data.
 */

import React from 'react';
import './ChartWindowNav.css';

function ChartWindowNav({ canBack, canForward, onBack, onForward, label }) {
  return (
    <div className="chart-window-nav-layer">
      <button
        type="button"
        className="chart-window-nav left"
        onClick={onBack}
        disabled={!canBack}
        title="Earlier"
        aria-label="Show earlier period"
      >
        <span className="material-symbols-rounded">chevron_left</span>
      </button>
      {label && <div className="chart-window-label">{label}</div>}
      <button
        type="button"
        className="chart-window-nav right"
        onClick={onForward}
        disabled={!canForward}
        title="Later"
        aria-label="Show later period"
      >
        <span className="material-symbols-rounded">chevron_right</span>
      </button>
    </div>
  );
}

export default ChartWindowNav;
